import React, { memo, useEffect, useRef, Fragment } from 'react'
import { formatDate } from 'utils/formatDatetime'
import { SMS, ISMSProps } from './SMS'

interface SMSListProps {
  list: ISMSProps[]
}

export const SMSList = memo<SMSListProps>(({ list }) => {
  const listRef = useRef<HTMLInputElement>(null)
  const scrollToBottom = () => {
    if (listRef.current) {
      listRef.current.scrollTop = listRef.current.scrollHeight
    }
  }
  useEffect(scrollToBottom, [list])

  const { length } = list
  let currentDate = ''
  return !length ? (
    <div className='mb4'>No Messages</div>
  ) : (
    <div className='message-list' ref={listRef}>
      {list.map((sms, i) => {
        const date = formatDate(sms.createdAt, 'monthDateFormat')
        const nextDate = currentDate !== date
        currentDate = date
        return (
          <Fragment key={sms.id}>
            {nextDate && (
              <div className='pv4 message-date tc text-secondary'>
                <hr />
                <span>{date}</span>
              </div>
            )}
            <SMS
              id={sms.id}
              createdAt={sms.createdAt}
              message={sms.message}
              sentByUserType={sms.sentByUserType}
              from={sms.from}
              shipmentId={sms.shipmentId}
              sendError={sms.sendError}
              to={sms.to}
              last={i === length - 1}
            />
          </Fragment>
        )
      })}
    </div>
  )
})
